
<div *ngIf="!shows" class="v-center">
  <app-spinner class="large"></app-spinner>
</div>
<div class="shows" *ngIf="shows">
  <ng-container *ngFor="let show of shows">

    <a class="show" [responsiveBackgroundImage]="show.logo1_landscape || show.logo2_landscape" (click)="activateShow(show, $event)" href="javascript:;">
      <h1>{{show.name}}</h1>
      <summary>
        {{show.description}}
      </summary>
    </a>
  </ng-container>
</div>
